import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons/faExclamationTriangle";
import ComponentWithRequest from "components/components/ComponentWithRequest/ComponentWithRequest";
import Icon from "components/components/Icon/Icon";
import { IconSize } from "components/components/Icon/IconWrapper";
import { RequestStatus } from "hooks/useRequest";
import React from "react";
import colours from "styles/colours";

import { StyledTableContainer, WarningWrapper } from "./style";

interface HasId {
  id: number | string;
}

interface Props<TItem> {
  children: JSX.Element;
  data: TItem[];
  dataFetchStatus: RequestStatus;
  rerequestData: () => void;
  rowCountWarningThreshold?: number;
}

const TableWithErrorHandling = <TItem extends HasId>({
  children,
  data,
  dataFetchStatus,
  rerequestData,
  rowCountWarningThreshold,
}: Props<TItem>): JSX.Element => {
  const requestSuccessfulOrNotStarted =
    dataFetchStatus === RequestStatus.SUCCESSFUL_OR_NOT_STARTED;

  const dataIsEmpty = requestSuccessfulOrNotStarted && data.length == 0;
  const rowCountOverThreshold =
    !!rowCountWarningThreshold && data.length > rowCountWarningThreshold;

  return (
    <StyledTableContainer
      data-test-id="table-container"
      style={{ minHeight: requestSuccessfulOrNotStarted ? "10rem" : "20rem" }}
    >
      <ComponentWithRequest
        dataFetchStatus={dataFetchStatus}
        rerequestData={rerequestData}
        dataIsEmpty={dataIsEmpty}
      >
        {rowCountOverThreshold && (
          <WarningWrapper>
            <Icon
              iconName={faExclamationTriangle}
              size={IconSize.small}
              colour={colours.elexonYellow}
            />
            <p>
              Your search criteria will return a large amount of data which may
              take time to render and cause unresponsiveness.
            </p>
          </WarningWrapper>
        )}
        {requestSuccessfulOrNotStarted && !dataIsEmpty && children}
      </ComponentWithRequest>
    </StyledTableContainer>
  );
};

export default TableWithErrorHandling;
